//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'UiGameHistoryGame',
  props: {
    id: {
      type: [Number, String],
      required: true
    },
    endAt: {
      type: String,
      default: null
    },
    totalBankUsd: {
      type: [Number, String],
      default: 0
    },
    usersCount: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      windowWidth: window.innerWidth
    };
  },
  filters: {
    formatTime(value) {

      if (!value) return '';
      // 如果传入的是 Date 对象
      if (value instanceof Date) {
        return value.toTimeString().split(' ')[0]; // 输出 "01:35:42"
      }
      // 如果传入的是 "YYYY-MM-DD HH:mm:ss" 格式
      if (typeof value === 'string' && value.includes(' ')) {
        return value.split(' ')[1]; // 截取空格后面的时间部分 "01:35:42"
      }
      // 如果传入的是 "YYYY-MM-DDTHH:mm:ss" ISO 格式
      if (typeof value === 'string' && value.includes('T')) {
        return value.split('T')[1].substring(0, 8); // 截取 "01:35:42"
      }
      return value;
    }
  },
  computed: {
    isLg() {
      return this.windowWidth <= 991;
    },
    formattedUsersCount() {
      return (this.usersCount || 0).toLocaleString();
    },
    formattedBank() {
      if (typeof this.totalBankUsd === 'number') {
        return this.totalBankUsd.toFixed(2);
      }
      return this.totalBankUsd || '0.00';
    }
  },
  mounted() {
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    handleResize() {
      this.windowWidth = window.innerWidth;
    }
  }
};
